"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_MORE_BUTTON_TYPE_VALUES = void 0;
var LOAD_MORE_BUTTON_TYPE_VALUES;
(function (LOAD_MORE_BUTTON_TYPE_VALUES) {
    LOAD_MORE_BUTTON_TYPE_VALUES[LOAD_MORE_BUTTON_TYPE_VALUES["TEXT"] = 1] = "TEXT";
    LOAD_MORE_BUTTON_TYPE_VALUES[LOAD_MORE_BUTTON_TYPE_VALUES["SHAPE"] = 2] = "SHAPE";
})(LOAD_MORE_BUTTON_TYPE_VALUES = exports.LOAD_MORE_BUTTON_TYPE_VALUES || (exports.LOAD_MORE_BUTTON_TYPE_VALUES = {}));
//# sourceMappingURL=load-more-button-type-values.js.map